<template>
  <WhitePage>
    <title-bar>アナウンス</title-bar>
    <!-- <help-nav></help-nav> -->
    <code-editor v-model="form.log"
      :iconList="iconList" :max="30" />
    <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
    <response-message :value="postMessage" />
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import CheckLogin from '@/components/mixin-checkLogin'
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
import CodeEditor from '@/components/CodeEditor'
import ResponseMessage from '@/components/ResponseMessage'
export default {
  components: {
    WhitePage,
    TitleBar,
    CodeEditor,
    ResponseMessage
  },
  data () {
    return {
      form: {
        log: [],
      },
      iconList: [],
      postMessage: {}
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.form.log = response.log
      this.iconList = response.iconList
    },
    onSubmit () {
      this.$store.dispatch('setTvAnnounce', this.form)
        .then((response) => {
          this.postMessage = response
        })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getTvAnnounce')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style scoped lang="scss">
</style>
